<template>
  <el-steps :active="active" align-center finish-status="success" class="import-steps">
    <el-step v-for="title in titles" :key="title" :title="title"></el-step>
  </el-steps>
</template>

<script>
export default {
  name: 'ImportSteps',
  props: {
    titles: { type: Array, required: true },
    active: { type: Number, default: 0 },
  },
};
</script>

<style>
.import-steps {
  margin-bottom: 20px;
}

.import-steps .el-step__icon {
  width: 22px;
  height: 22px;
  font-size: 12px;
  transition: transform 0.3s, background-color 0.3s, color 0.3s, border-color 0.3s;
}

.import-steps .el-step.is-horizontal .el-step__line {
  top: 10px;
}

.import-steps .el-step__head.is-success .el-step__line-inner {
  width: 100% !important;
  border-width: 1px !important;
}

.import-steps .el-step__head.is-process .el-step__icon {
  transform: scale(1.15);
  background: #67C23A;
  border-color: #67C23A;
  color: #fff;
}

.import-steps .el-step__title {
  font-size: 13px;
  line-height: 24px;
  transition: color 0.3s;
}

.import-steps .el-step__title.is-process {
  color: #67C23A;
  font-weight: 600;
}

/* transição do conteúdo entre as etapas — usada pelos fluxos de importação */
.import-slide-forward-enter-active,
.import-slide-forward-leave-active,
.import-slide-back-enter-active,
.import-slide-back-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.import-slide-forward-enter,
.import-slide-back-leave-to {
  opacity: 0;
  transform: translateX(24px);
}

.import-slide-forward-leave-to,
.import-slide-back-enter {
  opacity: 0;
  transform: translateX(-24px);
}
</style>
